import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import DashboardService from '../../../core/service'

export const getTotalAlert = createAsyncThunk(
  'dashboard/totalAlerts/getTotalAlert',
  async (prams, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getTotalAlert(prams)

      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (err) {
      return rejectWithValue({ loading: axios.isCancel(err) })
    }
  },
)
